import Counter from "@/components/ui/counter";
import useFormattedProductsData from "@/hooks/useFormattedProductsData";
import { PRODUCTS_API } from "@/lib/constants";
import { TGetProducts } from "@/types/products";
import { useQuery } from "@tanstack/react-query";
import { ProductsSection } from ".";
import { HottestLaunchesBanner } from "../../hottest-launches-banner";
import ProductListingLoadingState from "../loading-state";

async function getTodaysProductsData() {
	const url = new URL(PRODUCTS_API);
	url.searchParams.set("range", "today");

	const res = await fetch(url);
	if (!res.ok) {
		const { message } = await res.json();
		throw new Error(message);
	}

	const { data } = (await res.json()) as { data: TGetProducts };

	return data;
}

const TodaysProducts = () => {
	const {
		isLoading: isTodaysProductsLoading,
		isError: isTodaysProductsError,
		data: todaysProducts = [],
	} = useQuery({
		queryKey: ["todaysProducts"],
		queryFn: getTodaysProductsData,
		refetchOnWindowFocus: false,
	});
	const formattedTodaysProducts = useFormattedProductsData(todaysProducts);

	return (
		<>
			<HottestLaunchesBanner />
			{isTodaysProductsError ? (
				<span>Error fetching Today{"'"}s products</span>
			) : isTodaysProductsLoading ? (
				<ProductListingLoadingState />
			) : (
				<ProductsSection
					heading={
						<>
							<h2 className="text-xl font-bold text-gray-900 md:text-2xl">
								Today{"'"}s PropTech Launches
							</h2>
							<Counter />
						</>
					}
					products={formattedTodaysProducts}
				/>
			)}
		</>
	);
};

export default TodaysProducts;
